import {
  ChangeDetectorRef,
  Component, inject, Inject, Input, makeStateKey,
  OnDestroy,
  OnInit, PLATFORM_ID, signal, TransferState,
} from '@angular/core';
import {isPlatformBrowser, isPlatformServer, JsonPipe, NgClass, NgIf, NgOptimizedImage, NgStyle} from "@angular/common";
import {BehaviorSubject, delay, interval, max, min, of, startWith, Subscription, switchMap, tap} from "rxjs";
import {ImageService} from "../../services/image/image.service";
import {Image} from "../../types/image/image";
import {ImageTag} from "../../types/image-tag/image-tag";
import {ImageWithTagInterface} from "../../types/image-with-tag/image-with-tag.interface";
import {HttpContext, HttpContextToken} from "@angular/common/http";
// import {TagInterface} from "../art-image/art-image.component";

export interface TagInterface {
  title: string;
  delay: string;
  animationCLass?: string;
  positionClass?: string;
}

export interface TagStyleInterface {
  left?: string;
  top?: string;
  animationName?: string;

}

// Create a state key to store the data
const IMAGE_DATA_KEY = makeStateKey<boolean>('image-tag');

@Component({
  selector: 'app-art-image-fade-animated',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgStyle,
    NgIf,
    NgClass,
    JsonPipe
  ],
  templateUrl: './art-image-fade-animated.component.html',
  styleUrl: './art-image-fade-animated.component.scss',
})
export class ArtImageFadeAnimatedComponent implements OnInit, OnDestroy {

  image = {} as Image as any;

  private _inputData: [] = [];
  @Input() get inputData(): any {
    return this._inputData;
  }

  set inputData(value: any) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this._inputData = value;
    this.image = value.image;
    this.prevImage.set(this.image);
    this.currentImage.set(this.image);
    this.currentImageIndex.set(2);
    this.tags.set(this.getTagsArray(value.tags));

    setTimeout(() => {
      this.isTagShown.set(true);
    }, 500);

    // setTimeout(() => {
    //   this.isTagShown.set(false);
    // }, 4000);
    // setTimeout(() => {
    //   this.isTagShown.set(false);
    // }, 6000);

    // this.isLoading.next(true);

    console.log(this.image.path);

    // this.currentImage.set(imageTags.image);
    // this.currentImageIndex.set(2);
    // // this.prevImage.set(imageTags.image);
    // // if (!this.currentImage().path) {
    // //
    // // }
    //
    // this.tags.set(this.getTagsArray(imageTags.tags));
  }

  isLoading = new BehaviorSubject<boolean>(true);

  currentImage = signal<Image>({
    path: '/assets/img/1x1.jpg',
    signaturePath: '/assets/img/1x1.jpg',
  } as Image);
  prevImage = signal<Image>({
    path: '/assets/img/1x1.jpg',
    signaturePath: '/assets/img/1x1.jpg',
  } as Image);

  tags = signal<TagInterface[]>([]);

  currentImageIndex = signal<number>(1);
  isTagShown = signal<boolean>(true);
  tagsPosition = signal<string>('position-1');
  animatedClass = signal<string>('');

  private imageService = inject(ImageService);
  private changeDetection = inject(ChangeDetectorRef);
  private transferState = inject(TransferState);
  private subscription = new Subscription();

  constructor(
    @Inject(PLATFORM_ID) private platformId: any // Inject platformId to determine the environment
  ) {
  }

  ngOnInit() {
    // setTimeout(() => {
    //
    // });
    this.getNextImage();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private imageAlreadyLoaded(): boolean {
    return !!this.currentImage().path;  // If the current image has a path, it's already loaded
  }

  private getNextImage() {
    if (isPlatformBrowser(this.platformId)) {


      let firstShow = true;
      //
      if (this.transferState.hasKey(IMAGE_DATA_KEY)) {
        this.transferState.remove(IMAGE_DATA_KEY);
      //   // const imageTags = this.transferState.get(IMAGE_DATA_KEY, null);
      } else {
      //   this.loadInitialImage();
        firstShow = false;
      }

      // if (!this.imageAlreadyLoaded()) {
      //   this.loadInitialImage();  // Load immediately when navigating from a link
      // }

      const sub =
        interval(6000).pipe(
          tap(() => {
            this.isTagShown.set(false);
          }),
          switchMap(() => {
            this.isLoading.next(true);
            return this.imageService.getRandomImageWithTags();
          }),
          tap((imageTags) => this.tags.set(this.getTagsArray(imageTags.tags))),
          delay(100),
          tap(() => {
            this.isTagShown.set(true);
            this.isLoading.next(false);
          }),
          switchMap((imageTags) => {
            if (this.currentImageIndex() === 1) {
              this.currentImage.set(imageTags.image);
              this.currentImageIndex.set(2);
            } else {
              this.prevImage.set(imageTags.image);
              this.currentImageIndex.set(1);
            }
            return of(imageTags);
          }),
          delay(1300),
          switchMap((imageTags) => {
            if (this.currentImageIndex() === 2) {
              this.prevImage.set(this.currentImage());
            } else {
              this.currentImage.set(this.prevImage());
              // firstShow = true;
            }
            return of(imageTags);
          }),
          delay(4000),
          switchMap((imageTags) => {
            this.isTagShown.set(false);
            return of(imageTags)
          }),
        ).subscribe();

      this.subscription.add(sub);


    } else {
      //
      // this.randAttr2 = this.getRandomArbitrary(1, 1000);
      //
      // if (!this.currentImage().path) {
      //   this.prevImage.set(this.image);
      // }
      // this.tags.set(this.getTagsArray(this.inputTags));

      // const imageTags = await this.imageService.getRandomImageWithTags().toPromise();
      // if (!imageTags) return;
      // console.log('Image - ', this.randAttr1, imageTags.image.path);
      //
      //   this.image = imageTags.image;
      //   if (!this.currentImage().path) {
      //     this.prevImage.set(imageTags.image);
      //   }
      //   this.tags.set(this.getTagsArray(imageTags.tags));

      // const sub = this.imageService.getRandomImageWithTags().pipe().subscribe(imageTags => {
      //
      //   this.randAttr1 = this.getRandomArbitrary(1, 1000);
      //
      //   console.log('Image - ', this.randAttr1, imageTags.image.path);
      //
      //   this.image = imageTags.image;
      //   if (!this.currentImage().path) {
      //     this.prevImage.set(imageTags.image);
      //   }
      //   this.tags.set(this.getTagsArray(imageTags.tags));
      // });
      // this.subscription.add(sub);

      // this.transferState.set(IMAGE_DATA_KEY, true);
    }
  }

  getRandomArbitrary(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  // Function to load the first image immediately
  private loadInitialImage() {
    const sub = this.imageService.getLocalRandImage().pipe(
      tap(imageTags => {
        this.image = imageTags.image;

        this.currentImage.set(imageTags.image);
        this.currentImageIndex.set(2);
        // this.prevImage.set(imageTags.image);
        // if (!this.currentImage().path) {
        //
        // }

        this.tags.set(this.getTagsArray(imageTags.tags));
        // this.prevImage.set(imageTags.image);
        // this.currentImage.set(imageTags.image);
        // // this.currentImageIndex.set(1);
        //
        // this.tags.set(this.getTagsArray(imageTags.tags));
        // this.isTagShown.set(true);  // Show tags for the initial image
        // this.isLoading.next(false);
      })
    ).subscribe(() => {
      this.changeDetection.detectChanges();
    });

    this.subscription.add(sub);
  }

  private getTagsArray(imageTags: ImageTag[]): TagInterface[] {
    const usedClasses = new Set<string>();
    const randomNumber = Math.floor(Math.random() * 4) + 1;
    this.tagsPosition.set(`position-${randomNumber}`);
    return imageTags.map((tag) => {
      const randomDelay = this.getRandomDelay(100, 800);
      return {
        title: tag.title,
        delay: randomDelay + 'ms',
        animationCLass: `animation-${Math.floor(Math.random() * 7) + 1}`
      };
    });
  }

  private getRandomDelay(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

}
